import { render, staticRenderFns } from "./CourseMangerPage.vue?vue&type=template&id=200acdb0&scoped=true"
import script from "./CourseMangerPage.vue?vue&type=script&lang=js"
export * from "./CourseMangerPage.vue?vue&type=script&lang=js"
import style0 from "./CourseMangerPage.vue?vue&type=style&index=0&id=200acdb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200acdb0",
  null
  
)

export default component.exports